import { AnswerGiven } from "./AnswerGiven"
import { CorrectAnswer } from "./CorrectAnswer"
import { INPUT } from "./data/constants"

export class Prompt{
    label=""
    is_correct=false

    questionText =""
    isMediaPresent=false
    server_question_id=0
    server_prompt_id=0
    imageListQuestionBody=[]
    questionPresentation=INPUT
    answerGiven= new AnswerGiven()

    correctAnswer= new CorrectAnswer()

    choiceOptions=[]
    myExplanations=[]
    myConcepts=[]
}
